import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box, BoxProps } from "@mui/material";
import FieldBase from "./FieldBase";
import { FieldCoordinates } from "./FormEditorDataProvider";
import { FieldItem } from "./types";

interface FieldProps extends BoxProps {
  field: FieldItem;
  coordinates: FieldCoordinates;
  mergedActions?: {
    blockActions?: any;
  };
}
export default function Field({
  children,
  coordinates,
  field,
  mergedActions,
  ...rest
}: FieldProps) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: String(field?.id),
      data: { draggingItem: { field, originalCoordinates: coordinates } },
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  //Sorting end
  if (!field) {
    return null;
  }
  return (
    <Box
      sx={{
        display: "flex",
        //backgroundColor: "red",
        maxWidth:
          field.width && field.width !== 100 ? `${field.width}%` : "auto",
        flexBasis: field.width ? `${field.width}%` : undefined,
        flex: field.width ? undefined : 1,
      }}
      ref={setNodeRef}
      style={style}
    >
      <FieldBase
        field={field}
        coordinates={coordinates}
        draghandlerProps={{ ...attributes, ...listeners }}
        mergedActions={mergedActions}
        {...rest}
      />
    </Box>
  );
}
